import { get, keyBy } from "lodash";
import { writable } from "svelte/store";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";

const store = writable([]);

const updateInventory = async params => {
  const results = await HttpPromise({
    method: "POST",
    url: "api/retailer/retailer_inventories/batch_create",
    data: { retailer_inventories: params },
  });

  const updates = keyBy(results, "product_id");

  store.update(currentValues =>
    currentValues.map(quickOrderListProduct => {
      const productId = get(quickOrderListProduct, "product.product_id");
      if (!productId || !updates[productId]) return quickOrderListProduct;

      return {
        ...quickOrderListProduct,
        product: {
          ...quickOrderListProduct.product,
          retailer_inventory: updates[productId],
        },
      };
    }),
  );

  return results;
};

export default {
  ...store,
  updateInventory,
};
